export const GEOCODE = 'data/geocode/';

export const LOOKUP = 'data/location-lookup/';

export const AUTOCOMPLETE = 'data/location-autocomplete/';

export const DISCOVER = 'data/discover-near';
